<template>
    <v-dialog
        v-model="dialog"
        content-class="create-content-dialog"
        persistent
        >
        <div
            class="create-content-dialog-container"
        >
            <h3 v-if="type==='outbound_calls'" class="--green"> Broadcast to farmers through outbound calls </h3>
            <h3 v-if="type==='sms'" class="--green"> Broadcast to farmers through SMS </h3>
            <h3 v-if="type==='whatsapp'" class="--green"> Broadcast to farmers through WhatsApp </h3>
            <h3 v-if="type==='krishify_chat'" class="--green"> Broadcast to farmers through Krishify Chat </h3>
            <h3 v-if="type==='chatdirect'" class="--green"> Send message through Krishify Chat </h3>

            <hr/>
            
            <div v-if="type==='chat' || type==='chatdirect'" class="text-center mt-5">
                <v-icon class="icon" color="#419045">mdi-check-circle</v-icon>
                <h3 class="secondary-font"> Message sent! </h3>

                <p v-if="type!=='chatdirect'" class="text--secondary mt-2">Your message has been broadcasted to your <span class="--green"> 350 farmers </span>successfully.</p>
            </div>
            <div v-else class="text-center mt-5">
                <v-icon class="icon" color="#419045">mdi-check-circle</v-icon>
                <h3 class="secondary-font"> Your request has been sent successfully! </h3>

                <p class="text--secondary mt-2">Our team would get in touch with you soon.</p>
            </div>

            <div class="mt-3">
                <button @click="closeall" class="closebtn bold --green">Close</button>
            </div>
        </div>
    </v-dialog>
</template>

<script>
export default {
    name : 'broadcastSuccessModal',
    data(){
        return{
            isopen: this.dialog
        }
    },

    props : {
        dialog : {
            type : Boolean
        },
        type :{
            type: String
        }
    },
    methods:{
        closeall(){
            this.isopen=false
            this.$emit('close')
        }
    },
}
</script>

<style lang="scss" scoped>
.create-content-dialog-container {
	background-color: white;
	font-family: Roboto;
	padding: 20px;
}
.closebtn{
    width: 100%;
    background: rgba(49, 138, 54, 0.05);
    color: #1D8D56;
    padding: 14px;
    font-weight: 500;
    align-self: flex-end;
}
hr {
    margin: 15px 0;
    border: 0.5px solid #E3E3E3;
}

small {
    color: #C4C4C4;
}

.buttons-section {
	justify-content: space-between;
}

button {
	border-radius: 5px;
	font-size: 1rem;
	padding: 20px 0;
    width: 100%;
    background: rgba(49, 138, 54, 0.05);
    margin-top: 20px;
}
.icon{
    font-size: 6rem;
    margin: 40px auto;
}
.cancel,
.approval {
	width: 49%;
}

.cancel {
    background: rgba(138, 49, 49, 0.05);
    color: #AF3131;
}

.approval {
    background: linear-gradient(90.11deg, #318535 0.09%, #36983B 98.77%);
    box-shadow: 1px 3px 3px rgba(46, 73, 50, 0.25);
}

</style>

<style lang="scss">
.create-content-dialog.v-dialog {
	width: 60%;
}

.create-content-input fieldset {
	color: white !important;
}

@media all and (min-width: 1500px) {
	.create-content-dialog.v-dialog {
		width: 50%;
	}
}

</style>